<template>
  <div style="position: relative; height: 60px;" class="pa-0">
    <div class="hellgrau pa-0" style="position: absolute; left: 0; right: 0; top: 0; bottom: 0;">
      <v-divider class="mt-6 mr-5"></v-divider>
    </div>
    <v-row class="py-0 px-0 mr-3" style="position: absolute; left: 0; right: 0; top: 0; bottom: 0;">
      <step :nr="1" :complete="step > 1" :active="step==1" title="Hallo" class="px-1" @click="onStepClicked"></step>

      <step :nr="2" :complete="step > 2" :active="step==2" title="Levenssäulen" class="px-1" @click="onStepClicked"></step>

      <step :nr="3" :complete="step > 3" :active="step==3" title="Aktivitäten" class="px-1" @click="onStepClicked"></step>

      <v-img :src="require('@/assets/rocket_horiz.svg')" contain class="mt-3 mr-1" height="24" width="48"
             max-width="48"></v-img>
    </v-row>
  </div>
</template>

<script>
import Step from "@/components/Step";

export default {
  name: "InitializeProgress",
  components: {Step},
  props: {step: Number},
  data() {
    return {}
  },
  methods: {
    onStepClicked(nr) {
      if (this.step == nr)
        return;
      this.$emit("click", nr);
    }
  }
}
</script>

<style scoped>

</style>